// import React, { useEffect, useState } from 'react';
// import Layout from '../components/Layout';
// import { useNavigate } from 'react-router-dom';

// const Log = () => {
//   const [showModal, setShowModal] = useState(true); // Modal is shown by default
//   const navigate = useNavigate();

//   const handleLogout = () => {
//     console.log('Logging out...');
//     setShowModal(false);
//     // Add your logout logic here
//   };

//   const handleCancel = () => {
//     setShowModal(false);
//     navigate('/Dailylogs');
//   };

//   const handleOk = () => {
//     setShowModal(false);
//     navigate('/'); // Navigate to home page on OK
//   };

//   useEffect(() => {
//     // Optionally, you can add logic to automatically show modal here if needed
//     setShowModal(true);
//   }, []);

//   return (
//     <Layout>
//       {showModal && (
//         <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center z-50">
//           <div className="bg-white p-6 rounded-lg shadow-lg w-90">
//             <h2 className="text-xl font-semibold mb-4 text-center">Are you sure you want to logout?</h2>
//             <div className="flex justify-between mt-4">

//               <button
//                 onClick={handleCancel}
//                 className="bg-gray-500 text-white py-2 px-4 rounded hover:bg-gray-600"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleOk}
//                 className="bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600"
//               >
//                 OK
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </Layout>
//   );
// };

// export default Log;

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Log = () => {
  const [showModal, setShowModal] = useState(true);

  const navigate = useNavigate();

  const handleCancel = () => {
    setShowModal(false);

    navigate("/Dailylogs");
  };

  const handleOk = () => {
    setShowModal(false);

    localStorage.clear();

    sessionStorage.clear();

    navigate("/");
  };

  useEffect(() => {
    setShowModal(true);
  }, []);

  return (
    <>
      {showModal && (
        <div
          className="
          fixed
          inset-0
          w-screen
          h-screen
          bg-black/50
          flex
          justify-center
          items-center
          z-[99999]
          px-4
          "
        >
          <div
            className="
            bg-white
            w-full
            max-w-md
            rounded-2xl
            shadow-2xl
            p-8
            "
          >
            <div className="flex justify-center mb-5">
              <div
                className="
                w-16
                h-16
                rounded-full
                bg-red-100
                flex
                items-center
                justify-center
                text-red-600
                text-3xl
                font-bold
                "
              >
                !
              </div>
            </div>

            <h2
              className="
              text-2xl
              font-bold
              text-center
              text-gray-800
              mb-3
              "
            >
              Logout Confirmation
            </h2>

            <p
              className="
              text-center
              text-gray-500
              mb-8
              "
            >
              Are you sure you want to logout?
            </p>

            <div
              className="
              flex
              gap-4
              "
            >
              <button
                onClick={handleCancel}
                className="
                w-full
                h-12
                rounded-xl
                bg-gray-200
                hover:bg-gray-300
                font-semibold
                "
              >
                Cancel
              </button>

              <button
                onClick={handleOk}
                className="
                w-full
                h-12
                rounded-xl
                bg-red-600
                hover:bg-red-700
                text-white
                font-semibold
                "
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Log;
